import React from 'react';
import { GoogleMap, useJsApiLoader, MarkerF } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../Loaders/LoadingIndicator';

const GOOGLE_API_KEY = import.meta.env.VITE_APP_GOOGLE_API_KEY as string;

const containerStyle = {
    width: '100%',
    height: '420px',
    marginTop: '15px'
};

interface PropertyMapProps {
    lat: number;
    lng: number;
}

const PropertyMap: React.FC<PropertyMapProps> = ({ lat, lng }) => {
    const { t } = useTranslation();
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_API_KEY,
        version: 'weekly',
        libraries: ['maps', 'marker'],
        language: 'it',
        region: 'IT'
    });

    const hasValidCoordinates = Number.isFinite(lat) && Number.isFinite(lng)
        && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
    const center = { lat, lng };

    if (!GOOGLE_API_KEY) {
        return <div>{t('property.map.loadError', 'Impossibile caricare la mappa.')}</div>;
    }

    if (!hasValidCoordinates) {
        return <div>{t('property.map.invalidCoordinates', 'Posizione della mappa non disponibile.')}</div>;
    }

    if (loadError) return <div>{t('property.map.loadError', 'Impossibile caricare la mappa.')}</div>;

    if (!isLoaded) {
        return <LoadingIndicator />;
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
            options={{
                streetViewControl: false, // Disabilita Street View per un look più pulito
                mapTypeControl: false,    // Disabilita il selettore del tipo di mappa
            }}
        >
            <MarkerF position={center} />
        </GoogleMap>
    );
};

export default React.memo(PropertyMap);